import { render, staticRenderFns } from "./OverallBookingInformationSetting.vue?vue&type=template&id=a46f7b14&"
import script from "./OverallBookingInformationSetting.vue?vue&type=script&lang=ts&"
export * from "./OverallBookingInformationSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports